<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Group from '$lib/icons/group-svgrepo-com.svelte';
	import ChangeWithout from '$lib/icons/change_without_return-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#26D7D9] mt-4 text-white"><b>WP 4</b></span>
	<div class="flex">
		<h1 class="content-heading">
			Regional Tipping Points and co-development of adaptation options
		</h1>
		<ChangeWithout />
	</div>

	<blockquote class="content-blockquote">
		The WP will analyse regional tipping points in the southern African region towards the provision
		of climate services such as informing adaptation actions and policy. This will be done through a
		series of engagements with various actors within case studies to co-develop appropriate
		adaptation actions.
	</blockquote>

	<div class="flex pt-10">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team/#francois_engelbrecht">Francois Engelbrecht (WITS_GCI)</a>
		</div>
	</div>

	<div class="flex pt-4">
		<Group />
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#wits_gci">WITS-GCI</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gobabeb">Gobabeb</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#ub">UB</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#unza_iwemc">UNZA-IWRMC</a></div>
	</div>

	<h2 class="h4 pt-10 pb-2">Objectives</h2>
	Climate change may manifest in southern Africa through systematic incremental changes, but alternatively
	also through sudden and unprecedented change. Through either of these mechanisms, critical thresholds
	in the tolerance of water, agricultural or ecosystems may be reached, potentially leading to the collapse
	of these systems. Although policy makers in SADC and stakeholders across the sectors of water, agriculture
	and biodiversity are in urgent need of probabilistic estimates of such critical tipping points being
	exceeded over the next few decades, such estimates are currently not available. This project will assist
	in addressing this challenge. Through a co-production approach, it will firstly identify key sensitivities
	and thresholds in a number of important water, food and biodiversity systems in southern Africa. Secondly,
	it will project the likelihood of these systems collapsing over the next few decades through to the
	end of the 21st century. Finally, adaptation options will be formulated that can begin to enhance more
	integrated and robust decision making to some of the tipping point related risks that will be considered
	in southern Africa. At a regional scale, the project will explore the potential occurrence of “day
	zero” events across the major cities and industrial regions of southern Africa. Such tipping points
	in water availability may be induced through unprecedented multi-year droughts under climate change,
	in combination with urban and industrial growth that lead to enhanced water demand. Transboundary water
	transfers have been proposed as an adaptation to such impacts, for example from the Lesotho in South
	Africa to Gaborone in Botswana, or from the Okavango to Gaborone. This project will assess the feasibility
	of the supposed regional adaptation measure. Unprecedented multi-year droughts in combination with
	oppressive temperatures may also imply tipping points in the cattle industry, maize crop and biodiversity
	conservation in southern Africa. The project will explore the probabilities of tipping points, and
	how these may enhance other underlying drivers and vulnerabilities in the system. Mechanisms that can
	enhance resilience in these contexts will also be explored through engagements with stakeholders. For
	example, cross-country national parks and conservation areas that make feasible extensive animal migration
	have been proposed as a regional adaptation to such impacts. Across the southern African region tipping
	points may also be reached in terms of rural water scarcity and oppressive temperatures impacting on
	communities and their livelihoods. Such tipping points will also be explored and adaptation options
	will be sought through a co-production approach with stakeholders.
</div>
